import { createRoute, Navigate } from "@tanstack/react-router";
import { useAuthStore } from "@/stores/auth";
import { HomePage } from "@/pages/HomePage";
import { Route as RootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/",
  component: IndexRoute,
});

function IndexRoute() {
  const userId = useAuthStore((s) => s.userId);
  if (userId) {
    return <Navigate to="/meetings" />;
  }
  return <HomePage />;
}
